"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // (C) 2007-2014 GoodData Corporation

var dataProducts_1 = require("./admin/dataProducts");

var domainDataProducts_1 = require("./admin/domainDataProducts");

var domains_1 = require("./admin/domains");

var domainSegments_1 = require("./admin/domainSegments");

var clients_1 = require("./admin/clients");

var segments_1 = require("./admin/segments");

var logs_1 = require("./admin/logs");

var contracts_1 = require("./admin/contracts");
/**
 * Network-UI support methods. Mostly private
 *
 * @module admin
 * @class admin
 *
 */


var AdminModule =
/** @class */
function () {
  function AdminModule(xhr) {
    this.xhr = xhr;
    this.dataProducts = new dataProducts_1.DataProductsModule(this.xhr);
    this.domainDataProducts = new domainDataProducts_1.DomainDataProductModule(this.xhr);
    this.domains = new domains_1.DomainsModule(this.xhr);
    this.domainSegments = new domainSegments_1.DomainSegmentsModule(this.xhr);
    this.clients = new clients_1.ClientsModule(this.xhr);
    this.logs = new logs_1.LogsModule(this.xhr);
    this.contracts = new contracts_1.ContractsModule(this.xhr);
    this.segments = new segments_1.SegmentsModule(this.xhr);
  }

  return AdminModule;
}();

exports.AdminModule = AdminModule;